// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"af927534","148":"197dd03a","251":"091dcb0f","285":"75514719","307":"2d7bed36","453":"258b012d","483":"b9ddb742","569":"5d08351b","659":"66d68ad1","713":"3b5429db","742":"8932dc54","745":"bb44272d","859":"b4128076","897":"7e175c9a"}[chunkId] + ".chunk.js";
};